import '../Css/Adresses.css';
import Informations from './Informations';


export default function AdresseContent(props) {

  const orientation =props.orientation % 2 === 0 ? " " : "reversed";
  return (
    <div className={'adresse-tile '+ orientation}>
        <img className='adresse-icon' src={props.img} alt={props.imgAlt}></img>
        <div className='tile-content'>
            <div className='tile-title'>{props.title}</div>
            <div className='horaire'>{props.hour} - <a  className='adresse-maps' href={props.maps} target="_blank">{props.location}</a></div>
            <div className='adresse'></div>
            <div className='nom'>{props.description}</div>
            
        </div>
    </div>
  );
}